<h1 class="page-header"><i class="fa fa-check-square-o" aria-hidden="true"></i> Zone Assigned Assets </h1>
<div class="container-fluid">
	<div class="tab-content">
        <!-- Buttons above the Table -->
        <div class="page-button">

            <!-- ACTIONS Dropdown -->
            <div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
                <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-wrench"></i> ACTIONS <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">
                    <li (click)="editItemClicked()" [class.disabled]="!isSingleItemSelected()"><a><em class="fa fa-pencil"></em> EDIT</a></li>
                </ul>
            </div>

            <!-- FILTER Dropdown -->
            <div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
                <button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
                    <em class="fa fa-filter"></em> FILTER <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">
                    <li *ngFor="let filterOption of filterOptions" (click)="setFilterOption(filterOption)"><a>{{ filterOption.label }}</a></li>
                </ul>
            </div>
            <!-- Selected Filter Column -->
            <div *ngIf="selectedFilterOption != FilterOption_RemoveFilter" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
                {{ selectedFilterOption.label }}
            </div>
            <!-- Filter Value-->
            <div *ngIf="selectedFilterOption != FilterOption_RemoveFilter" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
                <input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20" [(ngModel)]="filterValue" (ngModelChange)="filterValueChanged()">
            </div>

            <!-- Results Per Page Dropdown -->
            <div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
                <button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
                    <em class="fa fa-bars"></em> RESULTS PER PAGE <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">
                    <li *ngFor="let value of resultsPerPageOptions" (click)="setPageSize(value)" [class.active]="value === selectedPageSize">
                        <a>{{ value }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Table displaying the data -->
        <table class="table tablesorter tablesorter-default table-hover" data-toggle="table" data-id-field="userid" role="grid">
            <thead>
                <tr role="row" class="tablesorter-headerRow">
                    <!-- Select All Checkbox -->
                    <th data-column="0" class="tablesorter-header tablesorter-headerUnSorted table-checkbox" tabindex="0"
                        scope="col" role="columnheader" aria-disabled="false" aria-controls="table1" aria-sort="none"
                        aria-label=": No sort applied, activate to apply an ascending sort"
                        style="user-select: none; width: 20px">
                        <div class="tablesorter-header-inner">
                            <div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
                                    [checked]="isAllSelected()" (change)="selectAllToggled($event)"><label for="checkbox"></label>
                            </div>
                        </div>
                    </th>
                    <!-- Zone Name -->
                    <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
                        data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
                        aria-disabled="false" aria-controls="table1" aria-sort="none"
                        aria-label="Name: No sort applied, activate to apply an ascending sort">
                        <div class="tablesorter-header-inner">Zone Name</div>
                    </th>
                    <!-- # of Assets -->
                    <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;"
                        data-field="name" data-sortable="true" data-column="1" tabindex="0" scope="col" role="columnheader"
                        aria-disabled="false" aria-controls="table1" aria-sort="none"
                        aria-label="Name: No sort applied, activate to apply an ascending sort">
                        <div class="tablesorter-header-inner"># of Assets</div>
                    </th>
                </tr>
            </thead>
            <tbody aria-live="polite" aria-relevant="all">
                <ng-container *ngFor="let zaa of zaas | paginate: { id: 'pagination', itemsPerPage: selectedPageSize, currentPage: currentPage, totalItems: total }">
                    <tr>
                        <!-- Checkbox -->
                        <td>
                            <div class="checkbox checkbox-inline"><input type='checkbox' class="styled" [checked]="isSelected(zaa.zone?.id)" (click)="selectItemToggled(zaa, $event)"><label for="checkbox"></label></div>
                        </td>
                        <!-- Zone Name -->
                        <td (click)="itemClicked(zaa)">{{ zaa.zone?.name }}</td>
                        <!-- # of Assets -->
                        <td (click)="itemClicked(zaa)">{{ zaa.asset_count }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <pagination-controls class="pagination" id="pagination" (pageChange)="pageChange($event)"
            [directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
        </pagination-controls>

	</div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog></ef-simple-indefinite-progress-dialog>

<!-- Dialog used to View / Edit the Assigned Assets for a specific Zone -->
<ef-zone-assigned-assets-dialog (refreshParent)="onRefreshParent()"></ef-zone-assigned-assets-dialog>
